<template>
  <div class="partners-swiper" :class="{ 'partners-swiper-mobile': isMobile }">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="partner in partners"
          :key="partner.logo"
          class="slide-item swiper-slide"
        >
          <a
            v-if="partner.url"
            :href="`/tracking?redir=${partner.url}&source=partnersSwiper`"
            target="_blank"
            :title="partner.label"
          >
            <img
              :alt="partner.label"
              class="responsive-img"
              :src="partnerLogo(partner.photo, '200x100')"
            />
          </a>
          <div v-else class="without-link">
            <img
              :alt="partner.label"
              class="responsive-img"
              :src="partnerLogo(partner.photo, '200x100')"
            />
          </div>
          <div class="slide-item-label" v-if="partner.category">
            {{ partner.category.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerLogo from '../../helpers/partner-logo'
import Swiper from 'swiper'

export default {
  data() {
    return {
      partners: [],
      swiper: null,
    }
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },

  created() {
    this.getData()

    setInterval(() => {
      if (this.swiper) {
        this.swiper.slideNext()
      }
    }, 1000)

    this.$el.addEventListener('resize', this.initSwiper)
  },

  beforeDestroy() {
    this.$el.removeEventListener('resize', this.initSwiper)
  },

  methods: {
    partnerLogo,

    getData() {
      axios.get('/partners/data').then(response => {
        this.partners = response.data
      })
    },

    initSwiper() {
      if (this.swiper) {
        this.swiper.destroy()
        this.swiper = null
      }

      const containerWidth = this.$el.offsetWidth
      const itemWidth = this.isMobile ? 108 : 132 // containerW+ marginLeft
      const logosWidth = this.partners.length * itemWidth

      if (logosWidth > containerWidth) {
        this.$nextTick(() => {
          this.swiper = new Swiper('.swiper-container', {
            loop: true,
            slidesPerView: 'auto',
            speed: 2000,
          })
        })
      }
    },
  },

  watch: {
    partners() {
      this.initSwiper()
    },
  },
}
</script>
